var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn-error",attrs:{"to":"/"}},[_c('svg',{staticClass:"mr-4",attrs:{"width":"16","height":"12","viewBox":"0 0 16 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16 6L6 0.226497V11.7735L16 6ZM0 7H7V5H0V7Z","fill":"#252E34"}})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }